<template>
  <div class="challenge-info-component">
    <div class="challenge-title">挑战内容</div>
    <div class="challenge-info">
      挑战{{ challenge.seq }}：{{ challenge.title }}
    </div>
    <div class="challenge-content" v-html="challenge.content"></div>
    <span class="challenge-hint">{{ challenge.hint }}</span>
  </div>
</template>

<script>
  export default {
    name: 'WorkChallengeInfoComponent',
    props: {
      challenge: {
        type: Object,
        default() {
          return {};
        },
      },
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .challenge-info-component {
    margin-bottom: @size-small;
    background: @color-white;
  }
  .challenge-title {
    margin-left: @size-base;
    padding: @size-base 0;
    border-bottom: @border-base;
    font-size: @font-size-medium;
    font-weight: @font-weight-primary;
    color: @color-text-base;
    line-height: 1;
  }
  .challenge-info {
    padding: @size-base @size-base @size-small @size-base;
    font-size: @font-size-base;
    font-weight: @font-weight-primary;
    color: @color-text-base;
  }
  .challenge-content {
    padding: 0 @size-base;
    font-size: @font-size-base;
    color: @color-text-light;
    line-height: 1.4;
  }
  .challenge-hint {
    display: inline-block;
    padding: @size-small @size-base @size-base @size-base;
    color: @color-text-lighter;
    font-size: @font-size-base;
  }

</style>
